import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { LoadingIndicator } from 'components/common';
import { Discussion } from 'components/common/discussion';
import { CoursesLanguageDropdown } from 'components/courses';

const FollowDiscussionsDiscussion = () => {
  const {
    pageState: { course, discussionId }
  } = useReduxState();

  const router = useRouter();

  // get selected language version filter option from URL, default to course.language if not set
  const currentLanguageVersion =
    typeof router.query.languageVersion === 'string'
      ? router.query.languageVersion
      : 'all';

  const { data, loading } = useApiData({
    onlyIf: Boolean(course?.id && discussionId),
    url:
      `admin/courses/${course.id}/discussions` +
      `?id=${discussionId}` +
      `&languageVersion=${currentLanguageVersion}`
  });

  const handleLanguageVersionFilter = (value: string) => {
    const query = { ...router.query };
    if (value === 'all') delete query.languageVersion;
    else query.languageVersion = value;

    router.replace({ query }, undefined, { shallow: true });
  };

  return loading ? (
    <LoadingIndicator />
  ) : (
    <Discussion
      blockId={discussionId}
      boxHeaderContent={
        course.languageVersions &&
        Object.keys(course.languageVersions).length > 0 && (
          <CoursesLanguageDropdown
            category="lighter"
            currentLanguage={currentLanguageVersion}
            includeAllOption={true}
            languageOptions={[
              course.language,
              ...Object.keys(course.languageVersions)
            ]}
            onChange={handleLanguageVersionFilter}
          />
        )
      }
      course={course}
      data={data?.discussions?.[0]?.data}
    />
  );
};

export default FollowDiscussionsDiscussion;
